<template class="bg-gray-100">
  <div class="bg-gray-100 h-full font-poppins">
    <div class="lg:grid max-lg:flex-col lg:auto-cols-max max-lg:flex lg:grid-cols-3 lg:content-center lg:items-center lg:h-28 border-solid border-stone-100 border-2 drop-shadow-md lg:rounded-sm bg-gray-100 lg:inline-block">
      <div class="lg:flex lg:text-center lg:mb-0 lg:ml-3 lg:col-start-1 lg:absolute lg:left-0 lg:top-3 lg:col-span-2 lg:mx-auto max-lg:mx-auto  lg:mb-8 lg:mx-0 lg:mt-2">
        <a href="https://www.planodesaudesaolucas.com.br/"><img class="lg:w-60 w-72 inline-block" src="../src/assets/logo.png"></a>
        <h1 class="text-neutral-900 whitespace-nowrap font-bold tracking-normal lg:inline-block lg:ml-4 max-lg:text-center	text-2xl lg:mt-5 mb-12 max-lg:mt-12 max-lg:mb-12 ">Rede Credenciada</h1>
      </div>
      <div class="lg:col-end-5 text-center lg:mr-3 space-x-4 mb-4 max-lg:flex-col lg:flex">
        <a href="https://www.gov.br/ans/pt-br"><img class="w-40 inline-block" src="../src/assets/logo_ans.gif"></a>
        <a href="https://www.gov.br/ans/pt-br"><img class="w-36 inline-block" src="../src/assets/num_ans.png"></a>
      </div>
    </div>
    
    <div>
      <div v-if="statusLoadingData === false" class="bg-gray-100 lg:h-screen lg:flex lg:justify-center lg:items-center">
        <loadingLogo/>
      </div>
      <div class="lg:flex bg-gray-100">
        <Pesquisa/>
        <div class="lg:ml-20 flex justify-center align-center h-full w-full">
          <div v-if="statusLoadingRoute" class="h-[40em] z-50 w-full flex justify-center items-center align-center" >
            <loadingLogo/>
          </div> 
          <router-view class="z-0"></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pesquisa from './components/Pesquisa.vue';
import loadingLogo from './components/loadingLogo.vue';
import { mapState } from "vuex";
import 'vue-select/dist/vue-select.css';

export default {
  computed: {
    ...mapState(['statusLoadingData', 'planos', 'statusLoadingRoute']),
  },
  components: {
    Pesquisa,
    loadingLogo
  },
}
</script>

